<div class="admin-container">
    <div>
        <app-admin-profile-card [pushedCharts]="pushedCharts"></app-admin-profile-card>
    </div>
    <div class="stats-container">
        <mat-card class="stats-card">
            <mat-card-header>
                <mat-card-title class="header4">Total Report Usage Metrics</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-progress-bar mode="indeterminate" *ngIf="isReportMetricsLoading"></mat-progress-bar>
                <div class="table-container" *ngIf="!isReportMetricsLoading">
                    <app-data-table [displayedColumns]="columns" [tableData]="reportMetrics" [initSortColumn]="0"
                        [initSortDirection]="'desc'" [selectable]="false"></app-data-table>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card class="stats-card">
            <mat-card-header>
                <mat-card-title class="header4">Report Usage By BAC</mat-card-title>
            </mat-card-header>
            <app-views-daily-report [byUser]="true"></app-views-daily-report>
        </mat-card>
        <!-- <mat-card class="stats-card">
            <mat-card-header>
                <mat-card-title class="header4">Report Usage Metrics</mat-card-title>
            </mat-card-header>
            <app-views-daily-report [byUser]="false"></app-views-daily-report>
        </mat-card> -->
        <!-- <mat-card class="stats-card">
            <mat-card-header>
                <mat-card-title class="header4">Chart Usage Metrics</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <app-views-daily-chart></app-views-daily-chart>
            </mat-card-content>
        </mat-card> -->
        <!-- <mat-card class="pushed-charts-card">
            <mat-card-header>
                <mat-card-title class="header4">Charts Pushed By You
                </mat-card-title>
            </mat-card-header>
            <mat-card-content *ngIf="userType === 'dealeradmin'">
                <table mat-table [dataSource]="pushedChartsDS" >
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell *matCellDef="let chart"> {{chart.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="views">
                        <th mat-header-cell *matHeaderCellDef> Views </th>
                        <td mat-cell *matCellDef="let chart"> {{chart.viewCount}} </td>
                    </ng-container>

                    <ng-container matColumnDef="countries">
                        <th mat-header-cell *matHeaderCellDef> Countries </th>
                        <td mat-cell *matCellDef="let chart"> {{chart.userCount}} </td>
                    </ng-container>

                    <ng-container matColumnDef="manage">
                        <th mat-header-cell *matHeaderCellDef> Manage </th>
                        <td mat-cell *matCellDef="let chart">
                            <i-feather class="table-icon" name="settings" (click)="goToManageChart(chart)"></i-feather>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="pushedChartColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: pushedChartColumns;"></tr>
                </table>
            </mat-card-content>
        </mat-card> -->
    </div>
</div>